<template>
  <router-view />
</template>

<script>
  export default {
    created() {
      const oldStyles = document.getElementById('landing-styles');
      if (oldStyles) oldStyles.remove();

      const css = document.createElement('link');
      css.setAttribute('href', '/css/zubmill.webflow.css');
      css.setAttribute('type', 'text/css');
      css.setAttribute('rel', 'stylesheet');
      css.setAttribute('id', 'main-styles');
      document.head.appendChild(css);
    },
  };
</script>
